import { logger } from "bernie-core";
import * as React from "react";
import { LocalizedComponentProps, withLocalization } from "bernie-l10n";
import {
  BlossomRendererFactory,
  BlossomRendererFactoryProps
} from "../renderer/BlossomRendererFactory";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";
import { BlossomRenderer } from "components/flexFramework/renderer/BlossomRenderer";

export interface BlossomComponentsProps
  extends LocalizedComponentProps,
    BlossomRendererFactoryProps {
  context: ExtendedContextStore;
  logger?: Logger;
  renderer?: BlossomRenderer;
}

/**
 * React component that uses the Blossom Renderer Factory to render the desired components.
 * It knows how to handle things like a module definition, flex components, composition and a template.
 */
@logger("BlossomComponents")
@withLocalization
export class BlossomComponents extends React.Component<BlossomComponentsProps> {
  public render() {
    const renderer = this.props.renderer || BlossomRendererFactory.get(this.props);

    return renderer.render(this.props.logger!, this.props.l10n, this.props.context);
  }
}
